export default "__VITE_ASSET__KuXAgvSI__"